import React, { ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { getUnitRole } from '../../../helpers/translations/unit-roles'
import { UserAvatar } from '../../common/Avatar'
import { theme } from '../../../theme/theme'
import { reverseUrl } from '../../../navigation/reverseUrl'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'
import { Icon, IconChoices } from '../../common/Icon'
import { Card } from '../../common/Card'
import { userQueries } from '../../../api/users'
import { getUserFullName } from '../../../helpers/user'
import { IUnitModel } from '../../../interfaces/models/units.interfaces'

interface RegisterUnitItemResidentProps {
  resident: {
    userId: string
    role:
      | ''
      | 'member'
      | 'resident'
      | 'tenant'
      | 'relative'
      | 'propertymanager'
      | 'customer-rep'
      | 'other'
  }
}

const RegisterUnitItemResident = ({
  resident,
}: RegisterUnitItemResidentProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  const { data: user } = useQuery(userQueries.getUser(resident.userId))

  if (!user) {
    return null
  }

  return (
    <Card
      url={reverseUrl('user:society-detail', {
        id: resident.userId,
        societyId: society?._id,
      })}
    >
      {{
        body: (
          <div className="flex items-center justify-between p-4">
            <div className="flex items-center gap-3">
              <UserAvatar user={user} size={42} />
              <div className="flex flex-col text-left">
                {resident.role && (
                  <p style={theme.textVariants.baseBold}>
                    {translate(getUnitRole(resident.role) as string)}
                  </p>
                )}
                <p style={theme.textVariants.base} translate="no">
                  {getUserFullName(user)}
                </p>
              </div>
            </div>
            <Icon icon={IconChoices.ARROW} />
          </div>
        ),
      }}
    </Card>
  )
}

interface RegisterUnitItemResidentsContent {
  unit: IUnitModel
}

export const RegisterUnitItemResidentsContent = ({
  unit,
}: RegisterUnitItemResidentsContent): ReactNode => {
  return (
    <div className="mt-1 flex flex-col gap-2">
      {unit.residentsList?.map((_resident) => {
        return (
          <RegisterUnitItemResident
            key={_resident.userId}
            resident={_resident}
          />
        )
      })}
    </div>
  )
}
